import { CellContext } from '@tanstack/react-table'

import { Log, MandatoryLogInformation } from '@/types/logs'
import { useManageLogOriginalRoute } from '@/modules/CombinedLogs/hooks/useManageLogOriginalRoute'
import { MissingInfo } from './MissingInfo'

import styles from '../../../ui/CombinedLogs.module.scss'
import { checkBulkCurtailmentValues } from '@/modules/CombinedLogs/helpers/checkBulkCurtailmentValues'

interface Props extends CellContext<Log, string | string[]> {
    isDataLoading: boolean
    field: MandatoryLogInformation
    label: string
    formatValue?: (value: unknown) => string
    getBulkCurtailmentValue?: (log: Log) => string
}

export const TripNestedInfo = ({
    isDataLoading,
    row,
    field,
    label,
    column,
    formatValue = (value) => value as string,
    getValue,
    getBulkCurtailmentValue,
}: Props) => {
    const { getElementAttributes } = useManageLogOriginalRoute(isDataLoading)
    const value = getValue()

    return (
        <div>
            <div
                {...getElementAttributes({
                    isOriginalTrip: !!row.original.originalTrip,
                })}
            >
                {value ? formatValue(value) : <MissingInfo log={row.original} label={label} field={field} />}
            </div>

            {row.original.originalTrip && row.original.originalTrip[column.id as keyof Log['originalTrip']] && (
                <div className={styles.originalRoutesFormContainer}>
                    <p>{formatValue(row.original.originalTrip[column.id as keyof Log['originalTrip']])}</p>
                </div>
            )}

            {row.original.bulkCurtailment && checkBulkCurtailmentValues(row.original) && getBulkCurtailmentValue && (
                <div className={styles.originalRoutesFormContainer}>
                    <span>{getBulkCurtailmentValue(row.original)}</span>
                </div>
            )}
        </div>
    )
}
